/** The subset of DataTransferItem we read, so this can be tested without a browser. */
interface ClipboardItemLike {
  kind: string;
  type: string;
  getAsFile: () => File | null;
}

function stamp(now: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
}

/**
 * Files on the clipboard or in a drop. Screenshots arrive as items rather than in `files` in
 * some browsers, and usually as "image.png", so they get a dated name.
 */
export function clipboardFiles(
  data: { items?: ArrayLike<ClipboardItemLike> | null; files?: ArrayLike<File> | null } | null,
  now = new Date()
): File[] {
  if (!data) return [];
  const fromItems = Array.from(data.items ?? [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null);
  const files = fromItems.length ? fromItems : Array.from(data.files ?? []);
  return files.map((file, i) => {
    const generic = !file.name || /^image\.(png|jpe?g|gif|webp)$/i.test(file.name);
    if (!generic || !file.type.startsWith('image/')) return file;
    const ext = file.type.split('/')[1]?.replace('jpeg', 'jpg') || 'png';
    const suffix = files.length > 1 ? `-${i + 1}` : '';
    return new File([file], `screenshot-${stamp(now)}${suffix}.${ext}`, { type: file.type });
  });
}

/** A unique key for a file waiting to be sent. */
export function pendingKey(file: File): string {
  return `${file.name}-${file.size}-${Date.now()}-${Math.random()}`;
}
